import { type ComponentChildren } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { styles } from './label.styles';
interface LabelProps {
  htmlFor?: string;
  children: ComponentChildren;
}
export function Label({
  htmlFor,
  children
}: LabelProps) {
  return <label htmlFor={htmlFor} {...stylex.props(styles.lbl)}>
      {children}
    </label>;
}